import { render, staticRenderFns } from "./PatientNew.vue?vue&type=template&id=18951e78"
import script from "./PatientNew.vue?vue&type=script&lang=js"
export * from "./PatientNew.vue?vue&type=script&lang=js"
import style0 from "./PatientNew.vue?vue&type=style&index=0&id=18951e78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports